class ScrollTrack extends HTMLElement {
  constructor() {
    super();

    this.maxScroll = 0;
    this.currentScroll = 0;

    this.btnPrev = this.querySelector("[data-prev]");
    this.btnNext = this.querySelector("[data-next]");

    this.slide = this.querySelector("[data-slide]");
    this.item = this.querySelector("[data-item]");

    this.init();
    this.setupMutationObserver();
  }

  init() {
    this.maxScroll =
      Number(this.slide.scrollWidth) - Number(this.slide.clientWidth);

    this.btnPrev.addEventListener("click", this.prevStep.bind(this));
    this.btnNext.addEventListener("click", this.nextStep.bind(this));
  }

  nextStep() {
    this.currentScroll += this.item.offsetWidth;

    if (this.maxScroll >= this.currentScroll) {
      this.slide.scrollTo(this.currentScroll, 0);
    } else {
      this.currentScroll = 0;
      this.slide.scrollTo(0, 0);
    }
  }

  prevStep() {
    this.currentScroll -= this.item.offsetWidth;

    if (this.currentScroll >= 0) {
      this.slide.scrollTo(this.currentScroll, 0);
    } else {
      this.currentScroll = this.maxScroll;
      this.slide.scrollTo(this.maxScroll, 0);
    }
  }

  recalculate() {
    this.maxScroll =
      Number(this.slide.scrollWidth) - Number(this.slide.clientWidth);
    this.currentScroll = 0;
    this.slide.scrollTo(0, 0);
    this.item = this.querySelector("[data-item]");
  }

  setupMutationObserver() {
    const observer = new MutationObserver(() => {
      this.recalculate();
    });

    const config = { childList: true };

    observer.observe(this.slide, config);
  }
}

customElements.define("scroll-track", ScrollTrack);

class ProductMiniCart extends HTMLElement {
  constructor() {
    super();

    this.productID = this.querySelector("[data-product-id]").value;
    this.variantID = this.querySelector("[data-variant-id]").value;
    this.stock = this.querySelector("[data-stock-variant]").value;
    this.productPlus = this.querySelector('[data-product-action="plus"]');
    this.productMinus = this.querySelector('[data-product-action="minus"]');
    this.btnRemove = this.querySelector("[data-remover-product]");
    this.productQdta = this.querySelector("[data-product-qtda]");

    this.init();
  }

  init() {
    this.btnRemove.addEventListener("click", this.removeProduct.bind(this));
    this.productPlus.addEventListener("click", this.plusProductQtda.bind(this));
    this.productMinus.addEventListener(
      "click",
      this.minusProductQtda.bind(this),
    );
    this.productQdta.addEventListener("change", this.productChange.bind(this));
  }

  cartUpdate() {
    fetch(`${routes.cart_url}?section_id=bf-minicart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["#shopify-section-bf-minicart"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  cartChange(productID, qtda) {
    this.productPlus.setAttribute("disabled", "disabled");
    this.productMinus.setAttribute("disabled", "disabled");
    this.productQdta.setAttribute("disabled", "disabled");

    const data = {
      id: productID,
      quantity: qtda,
    };

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 200) {
          this.cartUpdate();
        }

        return response.json();
      })
      .then((data) => {
        const { item_count } = data;

        document.querySelector(".min-cart__counter").innerHTML = item_count;
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        this.productPlus.removeAttribute("disabled");
        this.productMinus.removeAttribute("disabled");
        this.productQdta.removeAttribute("disabled");
      });
  }

  removeProduct() {
    this.cartChange(this.variantID, 0);
  }

  plusProductQtda() {
    const productQtdaValue = Number(this.productQdta.value);
    const stockqnt = Number(this.stock);

    this.productQdta.setAttribute("value", Number(this.productQdta.value) + 1);
    this.productQdta.dispatchEvent(new Event("change", { bubbles: true }));

    if (productQtdaValue == stockqnt) {
      this.productQdta.value = stockqnt;
      return;
    }
  }

  minusProductQtda() {
    this.productQdta.setAttribute("value", Number(this.productQdta.value) - 1);
    this.productQdta.dispatchEvent(new Event("change", { bubbles: true }));
  }

  productChange(event) {
    const target = event.currentTarget;

    this.cartChange(this.variantID, target.value);
  }
}

customElements.define("product-minicart", ProductMiniCart);

class ProductAddCart extends HTMLElement {
  constructor() {
    super();

    this.productIDInput = this.querySelector("[data-product-id]");
    this.productID = this.querySelector("[data-product-id]").value;
    this.productMinus = this.querySelector("[data-product-minus]");
    this.productQtda = this.querySelector("[data-product-qtda]");
    this.productPlus = this.querySelector("[data-product-plus]");
    this.btnAddCart = this.querySelector("[data-add-cart]");

    this.init();
    this.bindEvents();
  }

  init() {
    this.productPlus?.addEventListener(
      "click",
      this.plusProductQtda.bind(this),
    );
    this.productMinus?.addEventListener(
      "click",
      this.minusProductQtda.bind(this),
    );
    this.btnAddCart?.addEventListener("click", this.addCart.bind(this));
    this.productQtda?.addEventListener(
      "change",
      this.changeProductQtda.bind(this),
    );
  }

  bindEvents() {
    if (!this.variantChangeListener) {
      this.variantChangeListener = (event) => {
        this.productIDInput.value = event.detail.variantId;
      };
      document.addEventListener('variantChange', this.variantChangeListener);
    } else {
      return;
    }
  }

  // plusProductQtda() {
  //   this.productQtda.setAttribute("value", Number(this.productQtda.value) + 1);
  //   this.productQtda.dispatchEvent(new Event("change", { bubbles: true }));
  // }

  // minusProductQtda() {
  //   if (this.productQtda.value <= 1) {
  //     this.productQtda.setAttribute("value", 1);
  //     this.productQtda.dispatchEvent(new Event("change", { bubbles: true }));

  //     return;
  //   }

  //   this.productQtda.setAttribute("value", Number(this.productQtda.value) - 1);
  //   this.productQtda.dispatchEvent(new Event("change", { bubbles: true }));
  // }

  quantityErrorMessage(isError) {
    const element = document.querySelector(".product-selector");

    if (!element) {
      console.warn('.product-selector element not found');
      return;
    }

    let message = document.querySelector(".notification");

    if (!message) {
      console.warn('.notification element not found');
      return;
    }

    message.style.display = isError ? "block" : "none";
  }

  plusProductQtda() {
    const productQtdaValue = Number(this.productQtda.value);
    const stockqnt = Number(document.querySelector(".product-page .product .product__content-main").getAttribute("data-stock-qnt"));
    console.log('productQtdaValue:', productQtdaValue);
    console.log('stockqnt:', stockqnt);

    if (productQtdaValue >= stockqnt) {
        this.quantityErrorMessage(true);
        return;
    }
    this.productQtda.value = productQtdaValue + 1;

    this.quantityErrorMessage(false);
    this.productQtda.dispatchEvent(new Event("change", { bubbles: true }));
  }
  
  minusProductQtda() {
    if (this.productQtda.value <= 1) {
      this.productQtda.value = 1;
      this.productQtda.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
  
    this.productQtda.value = Number(this.productQtda.value) - 1;
    this.quantityErrorMessage(false);
    this.productQtda.dispatchEvent(new Event("change", { bubbles: true }));
  }

  changeProductQtda(event) {
    const target = event.currentTarget;

    if (target.value <= 1) {
      target.value = 1;
      return;
    }
  }

  addCart() {
    this.btnAddCart.setAttribute("disabled", "disabled");

    const data = {
      items: [
        {
          id: this.productIDInput.value || this.productID,
          quantity: this.productQtda?.value || 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        const { status } = json;

        this.cartUpdate();
        document.querySelector("#toggle-minicart").checked = true;
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        this.btnAddCart.removeAttribute("disabled");
      });
  }

  cartUpdate() {
    fetch(`${routes.cart_url}?section_id=bf-minicart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["#shopify-section-bf-minicart"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-add-cart", ProductAddCart);

class ProductQuickView extends HTMLElement {
  constructor() {
    super();

    this.handle = this.getAttribute("data-handle");
    this.addEventListener("click", this.handleQuickView.bind(this));
  }

  handleQuickView() {        
    if (window.location.pathname.includes('/products/')) {
      window.location.href = `/products/${this.handle}`;
    } else {
      this.renderProduct(this.handle);
    }
  }

  renderProduct(handle) {
    fetch(`/products/${handle}?section_id=bf-quick-view`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["#shopify-section-bf-quick-view"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .then(() => {
        const targetElement = document.querySelector("#shopify-section-bf-quick-view");
        if(targetElement) targetElement.classList.add("active");
        
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("button-quick-view", ProductQuickView);

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.productID = this.querySelector("[data-product-id]").value;
    this.btnAddCart = this.querySelector("[data-product-add-cart]");
    this.close = this.querySelector("[data-close-quick-view]");

    this.init();
  }

  init() {
    this.btnAddCart.addEventListener("click", this.addCart.bind(this));
    this.close;
    this.addEventListener("click", this.closeQuickView.bind(this));
  }

  closeQuickView() {
    this.closest("#shopify-section-bf-quick-view").classList.remove("active");
  }

  cartUpdate() {
    fetch(`${routes.cart_url}?section_id=bf-minicart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["#shopify-section-bf-minicart"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  addCart() {
    this.btnAddCart.setAttribute("disabled", "disabled");

    const data = {
      items: [
        {
          id: this.productID,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        const { status } = json;
        console.log({ status });

        this.cartUpdate();
        this.closest("#shopify-section-bf-quick-view").classList.remove(
          "active",
        );
        document.querySelector("#toggle-minicart").checked = true;
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        this.btnAddCart.removeAttribute("disabled");
      });
  }
}

customElements.define("quick-view", QuickView);


class ToggleModalSize extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.toggleModal.bind(this));
  }

  toggleModal(event) {
    event.preventDefault();
    event.stopPropagation();

    const currentTarget = event.currentTarget;

    if (currentTarget) {
      document.querySelector(".modal-size").classList.toggle("show-modal");
    }

    return;
  }
}

customElements.define("toggle-modal-size", ToggleModalSize);

class BFProductRecommendation extends HTMLElement {
  constructor() {
    super();
    this.limit = this.getAttribute('data-limit') || '3';
    this.productId = this.getAttribute('data-product-id');
    this.init();
  }

  init() {
    if (!this.productId) {
      return;
    }
    this.loadProductRecommendationsIntoSection();
  }

  loadProductRecommendationsIntoSection() {
    fetch(`/recommendations/products?section_id=product-recommendations&limit=${this.limit}&product_id=${this.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceElement = html.querySelector('.bf-product-recommendations');
        if (sourceElement) {
          this.innerHTML = sourceElement.innerHTML;
        } else {
          console.log('Source element not found in the API response');
        }
      })
      .catch((e) => {
        console.error('Error loading product recommendations:', e);
      });
  }
}

customElements.define("bf-product-recommendation", BFProductRecommendation);

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('bf-product-recommendation')) {
    const productId = document.querySelector('[data-product-id]')?.dataset.productId;
    if (productId) {
      const recommendationElement = document.createElement('bf-product-recommendation');
      recommendationElement.setAttribute('data-product-id', productId);
      recommendationElement.setAttribute('data-limit', '3');
      document.querySelector('.product-page')?.appendChild(recommendationElement);
    } else {
      console.log('Unable to find product ID for recommendations');
    }
  }
});

class ButtonAddCart extends HTMLElement {
  constructor() {
    super();
    this.productID = this.getAttribute("data-product-id");

    this.init();
  }

  init() {
    this.addEventListener("click", this.addCart.bind(this));
  }

  addCart(event) {
    const target = event.currentTarget;

    target.setAttribute("disabled", "disabled");

    const data = {
      items: [
        {
          id: this.productID,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        const { status } = json;
        console.log({ status });

        this.cartUpdate();
        document.querySelector("#toggle-minicart").checked = true;
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        target.removeAttribute("disabled");
      });
  }

  cartUpdate() {
    fetch(`${routes.cart_url}?section_id=bf-minicart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["#shopify-section-bf-minicart"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("btn-add-cart", ButtonAddCart);

class Variant extends HTMLElement {
  constructor() {
    super();

    this.variantID = this.getAttribute("data-target");
    this.init();
  }

  init() {
    this.addEventListener("mouseenter", this.toggleImage.bind(this));
  }

  toggleImage(e) {
    const target = e.currentTarget;

    const product = target.closest(".product-card");

    const images = product.querySelectorAll(".product-image img.image");

    images.forEach((image) => {
      const imageVariantID = image.getAttribute("data-id");
      image.classList.remove("active");

      if (imageVariantID == this.variantID) {
        image.classList.add("active");
      }
    });
  }
}

customElements.define("btn-variant", Variant);

class ButtonGoToTop extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.goToTop.bind(this));
  }

  goToTop() {
    document.body.scrollTop = 0; // Para navegadores antigos
    document.documentElement.scrollTop = 0; // Para navegadores modernos
  }
}

customElements.define("btn-top", ButtonGoToTop);

class Tabs extends HTMLElement {
  constructor() {
    super();

    this.currentType = "";
    this.types = this.querySelectorAll(".btn-tab");
    this.cards = this.querySelectorAll(".card-tab");

    this.init();
  }

  init() {
    this.types.forEach((type) =>
      type.addEventListener("click", this.toggleType.bind(this)),
    );

    if (!this.currentType) {
      this.currentType = this.types[0].getAttribute("data-target");
      this.types[0].classList.add("active");
      this.toggleCard(this.currentType);
    }
  }

  toggleType(event) {
    const current = event.currentTarget;

    const currentType = current.getAttribute("data-target");

    this.types.forEach((type) => {
      type.classList.remove("active");
    });

    current.classList.add("active");
    this.currentType = currentType;

    this.toggleCard(this.currentType);
  }

  toggleCard(type) {
    this.cards.forEach((card) => {
      const cartType = card.getAttribute("data-type");

      if (cartType === type) {
        card.style.display = "flex";
      } else {
        card.style.display = "none";
      }
    });
  }
}

customElements.define("tabs-meet", Tabs);

class ProductFloat extends HTMLElement {
  constructor() {
    super();

    this.scrollThreshold = window.screen.height;
    this.isHidden = true;

    this.init();
  }

  init() {
    window.addEventListener("scroll", this.updateScroll.bind(this));
  }

  updateScroll() {
    if (window.scrollY > this.scrollThreshold && !this.isHidden) {
      this.setAttribute("data-show", "true");
      this.isHidden = true;
    } else if (window.scrollY <= this.scrollThreshold && this.isHidden) {
      this.removeAttribute("data-show");
      this.isHidden = false;
    }
  }
}

customElements.define("product-float", ProductFloat);

class LocalStorageHandler extends HTMLElement {
  constructor() {
    super();
  }

  // Método para obter um valor do localStorage
  getValue(key) {
    try {
      const serializedValue = localStorage.getItem(key);
      return JSON.parse(serializedValue);
    } catch (error) {
      console.error("Erro ao obter valor do localStorage:", error);
      return null;
    }
  }

  // Método para definir um valor no localStorage
  setValue(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error("Erro ao definir valor no localStorage:", error);
    }
  }

  // Método para remover um item do localStorage
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Erro ao remover item do localStorage:", error);
    }
  }

  // Método para limpar todo o localStorage
  clearAll() {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("Erro ao limpar localStorage:", error);
    }
  }
}

class RulerShipping extends LocalStorageHandler {
  constructor() {
    super();

    this.inputControler = document.querySelector("#option-shipping");
    this.current_store = this.getAttribute("data-shipping-current");
    this.selectsShippings = this.querySelectorAll("[data-select-shipping]");
    this.optionsShippins = this.querySelectorAll(".custom-options__list li");
    this.currentShippin = this.querySelector("[data-shipping-current]");
    this.currentFlag = this.querySelector("[data-shipping-flag]");

    this.key = "BF_CURRENT_STORE";

    this.init();
  }

  init() {
    this.selectsShippings.forEach((selectShipping) => {
      selectShipping.addEventListener(
        "click",
        this.handleSelectShipping.bind(this),
      );
    });

    this.initalState();
  }

  initalState() {
    const current_store = this.getValue(this.key);

    if (!current_store) {
      this.showShippingSelect(this.current_store);
    } else {
      this.showShippingSelect(current_store);

      const target = this.querySelector(
        `[data-select-shipping="${current_store}"]`,
      );

      if (!target) {
        this.showShippingSelect(this.current_store);
      } else {
        this.selectOption(target);
      }
    }
  }

  handleSelectShipping(event) {
    const target = event.currentTarget;
    const shippingSelect = target.getAttribute("data-select-shipping");

    this.showShippingSelect(shippingSelect);

    this.selectOption(target);

    this.closeOptionSelect();
  }

  showShippingSelect(shippingSelect) {
    const shippings = document.querySelectorAll("[data-shipping]");

    shippings.forEach((shipping) => {
      const shippingValue = shipping.dataset["shipping"];
      const flag = shipping.dataset["flag"];

      if (shippingValue.toLowerCase() === shippingSelect.toLowerCase()) {
        shipping.style.display = "block";
        this.currentShippin.innerText = shippingValue;

        this.toggleFlag({ src: flag, alt: shippingValue });

        this.setValue(this.key, shippingValue);
      } else {
        shipping.style.display = "none";
      }
    });
  }

  selectOption(target) {
    this.optionsShippins.forEach((option) => {
      option.classList.remove("current");
    });

    target.closest("li").classList.add("current");
  }

  closeOptionSelect() {
    this.inputControler.checked = false;
  }

  toggleFlag({ src, alt }) {
    if (!src) return;

    this.currentFlag.innerHTML = "";

    const imageTag = document.createElement("img");
    imageTag.src = src;
    imageTag.alt = alt;
    imageTag.height = 24;

    this.currentFlag.appendChild(imageTag);
  }
}

customElements.define("ruller-shipping", RulerShipping);

class RecentlyView extends LocalStorageHandler {
  constructor() {
    super();

    this.currentHandle = this.dataset["handle"];
    this.maxItems = this.dataset["limit"];
    this.key = "BF_PRODUCTS_RECENTY_VIEW";
    this.products = [];
    this.targetElement = this.querySelector(".shelf__slide");
    this.init();
  }

  init() {
    this.getRegisterViews();
    this.registreView();
    this.pipeProducts();
  }

  getRegisterViews() {
    this.products = this.getValue(this.key) || [];
  }

  registreView() {
    if (!this.products.includes(this.currentHandle)) {
      if (this.products.length == this.maxItems) {
        this.products.shift();
      }

      this.products.push(this.currentHandle);

      this.setValue(this.key, this.products);

      this.getRegisterViews();
    }
  }

  pipeProducts() {
    let products = this.products;

    products = products.filter((product) => product !== this.currentHandle);

    if (products.length <= 0) {
      this.style.display = "none";
      return;
    }

    products.forEach((product) => {
      this.renderProduct(product);
    });
  }

  renderProduct(handle) {
    fetch(`/products/${handle}?section_id=bf-card-product`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const body = html.body.childNodes;

        const card = body[0].querySelector(".product-card");

        this.targetElement.appendChild(card);
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("recenty-view", RecentlyView);



if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }

      connectedCallback() {
        this.initializeToggle();
      }

      initializeToggle() {
        const toggleButton = this.querySelector('.footer__note-toggle');
        const noteContent = this.querySelector('#cart-note-content');

        if (toggleButton && noteContent) {

          toggleButton.addEventListener('click', () => {
            const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
              noteContent.setAttribute('hidden', '');
              toggleButton.setAttribute('aria-expanded', 'false');
              toggleButton.textContent = "Add";

              noteContent.style.display = 'none';
            } else {
              noteContent.removeAttribute('hidden');
              toggleButton.setAttribute('aria-expanded', 'true');
              toggleButton.textContent = "Hide";

              noteContent.style.display = 'block';
            }
          });
        } else {
          console.error("Elementos de toggle ou nota não foram encontrados.");
        }
      }
    }
  );
}